module.exports = __webpack_public_path__ + "static/media/de.89a3cdc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/de.png
// module id = 112
// module chunks = 0